function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { any, arrayOf, bool, func, node, oneOf, shape, string } from 'prop-types';
import clsx from 'clsx';
import RadioGroup from '@mui/material/RadioGroup';
import SovosFormControlLabel from '../sovos-form-control-label';
import SovosRadio from '../sovos-radio';

/**
 * `SovosRadioGroup` is a helpful wrapper used to group `SovosRadio`
 * components that provides an easier API. Prefer `options` array to `children`
 */
const SovosRadioGroup = _ref => {
  var _SovosRadio;
  let {
    children,
    className,
    color = 'primary',
    name,
    onChange,
    options,
    row,
    size = 'medium',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(RadioGroup, _extends({
    className: clsx('sovosRadioGroup', className),
    onChange: onChange,
    name: name,
    row: row
  }, props), options ? options.map(item => /*#__PURE__*/React.createElement(SovosFormControlLabel, {
    control: _SovosRadio || (_SovosRadio = /*#__PURE__*/React.createElement(SovosRadio, {
      color: color,
      size: size
    })),
    disabled: item.disabled,
    key: item.value,
    label: item.label,
    value: item.value
  })) : children);
};
SovosRadioGroup.propTypes = {
  /**
   * The content of the component, accepts `SovosFormControlLabel`
   * components with `SovosRadio` as the `control` prop. **Note**: if
   * `options` prop is passed, `children` will not render.
   */
  children: node,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Material UI theme color of the component
   */
  color: oneOf(['primary', 'default']),
  /**
   * The name used to reference the value of the control. If you don't
   * provide this prop, it falls back to a randomly generated name.
   */
  name: string,
  /**
   * Callback fired when input value is changed `function(event: object) => void`
   */
  onChange: func.isRequired,
  /**
   * Array of radio control object props
   */
  options: arrayOf(shape({
    disabled: bool,
    label: string,
    value: any
  })),
  /**
   * Display group of elements in a compact row.
   */
  row: bool,
  /**
   * Size of the radio buttons
   */
  size: oneOf(['small', 'medium'])
};
export default SovosRadioGroup;